import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import PhotoModal from './PhotoModal';
import t from '../../common/t';
export default class Picker extends Component {
  startDrag(event, item) {
    const state = this.attrs.state;
    if (this.attrs.disabled || state.pending() || event.button !== 0) return;
    this.drag = {
      item,
      id: event.pointerId,
      target: event.currentTarget
    };
    event.currentTarget.setPointerCapture(event.pointerId);
    event.preventDefault();
  }
  dragOver(event) {
    if (!this.drag || event.pointerId !== this.drag.id) return;
    const figure = document.elementFromPoint(event.clientX, event.clientY)?.closest('[data-ccot-photo-index]');
    if (figure && this.element.contains(figure)) this.attrs.state.move(this.drag.item, Number(figure.dataset.ccotPhotoIndex));
    event.preventDefault();
  }
  endDrag(event) {
    if (!this.drag || event.pointerId !== this.drag.id) return;
    if (this.drag.target.hasPointerCapture(event.pointerId)) this.drag.target.releasePointerCapture(event.pointerId);
    this.drag = null;
  }
  view() {
    const state = this.attrs.state,
      options = app.forum.attribute('ccotPostImages');
    if (!state || app.session.user?.id() !== state.owner) return null;
    const disabled = !!this.attrs.disabled;
    const verified = !!app.session.user?.attribute('ccotPhoneVerified');
    const uploadDisabled = disabled || !options.simple || !options.enabled || !verified || state.items.length >= options.max_count;
    const sortingDisabled = disabled || state.items.some(item => item.status !== 'done');
    return m('section.CCOT-post-picker', {
      'aria-label': t('lib.post_images_photos')
    }, [state.grouped && m('p.CCOT-help', t('lib.post_images_grouped')), state.items.length > 1 && m('p.CCOT-help', t('lib.post_images_sort_help')), m('.CCOT-post-thumbnails', state.items.map((item, index) => m('figure', {
      key: item.key,
      'data-ccot-photo-index': index
    }, [item.deleted ? m('.CCOT-photo-pending', t('lib.post_images_deleted')) : item.thumb ? m('button.CCOT-photo-preview', {
      type: 'button',
      'aria-label': t('lib.post_images_preview', {
        number: index + 1
      }),
      onclick: () => app.modal.show(PhotoModal, {
        image: item.image,
        number: index + 1
      })
    }, m('img', {
      src: item.thumb,
      alt: t('lib.post_images_preview', {
        number: index + 1
      }),
      onerror: event => {
        event.target.alt = t('lib.post_images_blocked');
      }
    })) : m('.CCOT-photo-pending', {
      role: 'status'
    }, item.status === 'failed' ? t('lib.post_images_failed') : t('lib.post_images_uploading', {
      progress: item.progress
    })), m('figcaption', [item.status === 'failed' && m(Button, {
      type: 'button',
      className: 'Button Button--link',
      disabled,
      onclick: () => state.retry(item)
    }, t('lib.post_images_retry')), m(Button, {
      type: 'button',
      className: 'Button Button--link',
      disabled: disabled || item.status === 'uploading' || item.status === 'removing',
      loading: item.status === 'removing',
      onclick: () => state.remove(item)
    }, t('lib.post_images_remove'))]), state.items.length > 1 && m('.CCOT-photo-order', [m('button.Button.CCOT-photo-drag', {
      type: 'button',
      disabled: sortingDisabled,
      'aria-label': t('lib.post_images_drag', {
        number: index + 1
      }),
      onpointerdown: e => this.startDrag(e, item),
      onpointermove: e => this.dragOver(e),
      onpointerup: e => this.endDrag(e),
      onpointercancel: e => this.endDrag(e)
    }, m('i.fas.fa-grip-vertical', {
      'aria-hidden': 'true'
    })), m(Button, {
      type: 'button',
      className: 'Button Button--icon',
      icon: 'fas fa-arrow-left',
      disabled: sortingDisabled || index === 0,
      'aria-label': t('lib.post_images_move_before', {
        number: index + 1
      }),
      onclick: () => state.move(item, index - 1)
    }), m(Button, {
      type: 'button',
      className: 'Button Button--icon',
      icon: 'fas fa-arrow-right',
      disabled: sortingDisabled || index === state.items.length - 1,
      'aria-label': t('lib.post_images_move_after', {
        number: index + 1
      }),
      onclick: () => state.move(item, index + 1)
    })])]))), m('label.Button.CCOT-add-photo', {
      className: uploadDisabled ? 'disabled' : '',
      'aria-disabled': uploadDisabled
    }, [m('i.fas.fa-image', {
      'aria-hidden': 'true'
    }), ' ', t('lib.post_images_add'), m('input', {
      type: 'file',
      multiple: true,
      accept: 'image/jpeg,image/png,image/webp',
      disabled: uploadDisabled,
      onchange: event => {
        state.select(Array.from(event.target.files || []));
        event.target.value = '';
      }
    })]), (!options.simple || !options.enabled) && m('p.CCOT-help', {
      role: 'status'
    }, t('lib.post_images_upload_disabled')), options.enabled && !verified && m('p.CCOT-help', {
      role: 'status'
    }, t(app.forum.attribute('ccotShowLegacyEntry') === false ? 'lib.post_images_account_unavailable' : 'lib.post_images_verify_required')), m('p.CCOT-help', t('lib.post_images_limits', {
      count: options.max_count,
      size: options.max_mb
    })), state.error && m('p.Alert.Alert--error', {
      role: 'alert'
    }, state.error)]);
  }
}
flarum.reg.add('bushcraftcn-ccot', 'forum/postImages/Picker', Picker);